import { useCommunityFeedActionMutation } from './useCommunityFeedActionMutation';

const UNBAN_MEMBER_ACTION = '/unban_community_member';

interface UnbanMemberVars {
  memberId: string;
}

export const useUnbanMemberMutation = () =>
  useCommunityFeedActionMutation<UnbanMemberVars>({
    buildRequest: ({ memberId }) => ({ path: UNBAN_MEMBER_ACTION, fields: { member_id: memberId } }),
  });
